import {
  MonitorIcon,
  MoneyIcon,
  DollarIcon,
  TrendingDownIcon,
} from '../icons';
import { KpiSkeleton } from './Skeletons';
import { FaExclamationTriangle } from 'react-icons/fa';

const iconMap = {
  t1: <MonitorIcon />,
  t2: <MoneyIcon />,
  t3: <DollarIcon />,
  t4: <DollarIcon />,
  t5: <TrendingDownIcon />,
  t6: <FaExclamationTriangle />,
};

// iconOverrides: { t1: <SomeIcon />, ... } — lets pages swap individual icons
// warnings: { t1: { count: number, onClick: fn }, ... } — shows a clickable ⚠️ badge on matching cards
const KpiRow = ({ kpiData, loading, iconOverrides = {}, warnings = {} }) => {
  if (loading || !kpiData?.length) return <KpiSkeleton />;
  const colClass = kpiData.length === 5 ? 'kpi-row cols-5' : kpiData.length === 3 ? 'kpi-row cols-3' : 'kpi-row';
  return (
    <div className={colClass}>
      {kpiData.map((item) => {
        const warn = warnings[item.type];
        const hasWarning = warn && warn.count > 0;
        return (
          <div key={item.id} className={`kpi ${item.type}`} style={{ position: 'relative' }}>
            <div className="ico">{iconOverrides[item.type] ?? iconMap[item.type]}</div>
            <div style={{ flex: 1 }}>
              <div className="lbl">{item.title}</div>
              <div className="val">{item.value}</div>
              <div className="sub">{item.subtitle}</div>
            </div>
            {hasWarning && (
              <button
                onClick={warn.onClick}
                title={`${warn.count} ASG${warn.count !== 1 ? 's' : ''} with instance errors — click to view`}
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '10px',
                  background: 'rgba(245,124,0,0.10)',
                  border: '1px solid rgba(245,124,0,0.35)',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '13px',
                  padding: '2px 7px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  color: '#f57c00',
                  fontWeight: 600,
                  lineHeight: 1.4,
                }}
              >
                <FaExclamationTriangle style={{ fontSize: '11px' }} /> <span style={{ fontSize: '12px' }}>{warn.count}</span>
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default KpiRow;
